module.exports = __webpack_public_path__ + "static/battle02-sq-3b958b90f282ae8c377b6161dba391a2.png";